import {
  BookOpen,
  FileText,
  LayoutDashboard,
  Menu,
  MessageSquare,
  Tags,
  Users,
  X,
} from "lucide-react";
import { Button } from "../../components/ui/button";
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export const Sidebar = () => {
  const location = useLocation();

  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeTab") || "dashboard"
  );
  const [sidebarOpen, setSidebarOpen] = useState(true);

  // NOTE: "Locations" admin removed — locations are now coordinate-based
  // and managed automatically via Nominatim. No admin-curated tree to manage.
  const menuItems = [
    { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
    { id: "users", label: "User Management", icon: Users },
    { id: "categories", label: "Categories", icon: Tags },
    { id: "chat", label: "Chat Monitor", icon: MessageSquare },
    { id: "reports", label: "Reports", icon: FileText },
    { id: "resources", label: "Resources", icon: BookOpen },
  ];

  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  useEffect(() => {
    const currentPath = location.pathname.split("/").pop();
    if (menuItems.some((item) => item.id === currentPath)) {
      setActiveTab(currentPath);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <div
      className={`bg-white shadow-lg transition-all duration-300 ${
        sidebarOpen ? "w-64" : "w-16"
      }`}
    >
      <div className="p-4 border-b">
        <div className="flex items-center justify-between">
          {sidebarOpen && (
            <img src="/igbanwo-logo.png" alt="Igbanwo Logo" className="h-9" />
          )}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="p-2"
          >
            {sidebarOpen ? (
              <X className="w-4 h-4" />
            ) : (
              <Menu className="w-4 h-4" />
            )}
          </Button>
        </div>
      </div>

      <nav className="p-4">
        <ul className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.id}>
                <Link to={`/admin/${item.id}`}>
                  <Button
                    variant={activeTab === item.id ? "secondary" : "ghost"}
                    className={`w-full justify-start ${!sidebarOpen && "px-2"}`}
                    onClick={() => setActiveTab(item.id)}
                  >
                    <Icon className="w-5 h-5" />
                    {sidebarOpen && <span className="ml-3">{item.label}</span>}
                  </Button>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};